<script setup>
import SlidingPill from '../elements/SlidingPill.vue'

const props = defineProps({
  stopwatch: Object,
  showDays: {
    type: Boolean,
    default: true,
  },
})

const emit = defineEmits(['timeline'])

const formattedStopwatch = computed(() => {
  return [
    ...(props.showDays ? [{ value: props.stopwatch.days, label: props.stopwatch.days === 1 ? 'dag' : 'dagen' }] : []),
    { value: props.stopwatch.hours.toString(), label: 'uur' },
    { value: props.stopwatch.minutes.toString().padStart(2, '0'), label: 'min' },
    { value: props.stopwatch.seconds.toString().padStart(2, '0'), label: 'sec' },
  ]
})
</script>

<template>
  <SlidingPill @timeline="emit('timeline', $event)">
    <div class="px-6">
      <span v-for="{ value, label } in formattedStopwatch" :key="label" class="mx-2">
        <span class="tabular-nums">{{ value }}</span>
        {{ label }}
      </span>
    </div>
  </SlidingPill>
</template>
